import { render, staticRenderFns } from "./SettingLimitTime.vue?vue&type=template&id=5c42b9b7"
import script from "./SettingLimitTime.vue?vue&type=script&lang=js"
export * from "./SettingLimitTime.vue?vue&type=script&lang=js"
import style0 from "./SettingLimitTime.vue?vue&type=style&index=0&id=5c42b9b7&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports